module.exports = __webpack_public_path__ + "img/fruit-apples-350x184.90338a51.jpg";